<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="tips-box">
        <div class="tips-title">注意：</div>
        <div class="tips">
          <span>1.为了数据完整，下载的文件只保留3天的有限期，过了就自动删除记录和文件，请早些下载！</span>
          <span>2.导出表格如果等待时间太长，可以关闭标签页，或关闭浏览器，下载完成后即可直接下载文件。</span>
        </div>
      </div>
      <div class="form-box mt20">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="身份：">
            <el-select v-model="query.identity" placeholder="请选择" clearable size="small">
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in identityList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邀请时间：">
            <el-date-picker v-model="query.times" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-container mt20">
        <div class="table-tips">
          <span>下载记录</span>
          <el-button type="primary" icon="el-icon-refresh-right" size="mini">刷新</el-button>
        </div>
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <el-table-column label="文件名称" prop="title" width="300"></el-table-column>
          <el-table-column label="状态" prop="status" width="300">
            <template slot-scope="{row}">
              <el-progress :stroke-width="12" :percentage="row.status" color="#60B7DC"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="create_time" sortable="custom" align="center"></el-table-column>
          <el-table-column label="操作人" prop="handle" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="{row}">
              <span style="color: #3A8EE6;cursor: pointer;" v-if="row.status==100">下载</span>
              <span style="color: #999999;" v-else>生成中</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        isDisplay: 1,
        times:'',
        identity:''
      },
      selectItems: [],
      identityList: [
        {name:'教育总监',id:1},
        {name:'督导',id:2},
        {name:'技术老师',id:3}
      ]
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
     getTime(event) {
      this.times = JSON.parse(event)
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
     handleFilter() {
      this.$refs.times.timeIndex = ''
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query.keyword = ''
      this.query.identity = ''
      this.times = null
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
        this.navIndex = index;
        this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/business/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysDataconstantApi.fetchList(this.query).then(({ data }) => {
        data.list = [
          {title: '文件名称',status: 100,create_time: '2024-10-08 15:32:15',handle: '张三'},
          {title: '文件名称',status: 80,create_time: '2024-10-08 15:32:15',handle: '张三'},
          {title: '文件名称',status: 100,create_time: '2024-10-08 15:32:15',handle: '张三'},
          {title: '文件名称',status: 50,create_time: '2024-10-08 15:32:15',handle: '张三'},
          {title: '文件名称',status: 100,create_time: '2024-10-08 15:32:15',handle: '张三'}
        ]
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 页面跳转
     */
    toPage(path,row,type) {
      if(type) {
        this.$router.push(`${path}?id=${row.id}&index=${type-1}`)
      }else{
        this.$router.push(`${path}?id=${row.id}`)
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .tips-box {
    border: 1px solid #5DBDE7;
    .tips-title {
      font-size: 16px;
      line-height: 48px;
      color: #FFFFFF;
      background-color: #60B7DC;
      text-indent: 20px;
    }
    .tips {
      padding: 20px;
      font-size: 14px;
      color: #6C6C6C;
      &>span {
        display: block;
        margin-top: 10px;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .form-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    background-color: #eff8fd;
  }

  .table-tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 0 10px;
    background-color: #eff8fd;
    border-bottom: 1px solid #ebeef5;
    &>span {
      font-size: 14px;
      color: #101010;
      font-weight: bold;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }

  ::v-deep .el-progress__text {
    font-size: 12px !important;
  }
</style>